export default {
    'loading': '加载中'
};
